import { useLocation } from 'react-router-dom';

import { AppRoutes } from 'constants/routes-paths.constants';
import { ComplaintForm } from 'page-components/complaints/ComplaintForm';
import { PageLayout } from 'page-components/page-layout/PageLayout';

export const Complaint = () => {
  const { pathname } = useLocation();

  const editTitle = pathname === AppRoutes.complaintCreate ? 'create_complaint' : 'edit_complaint';
  const titleText = pathname.includes('view') ? 'view_complaint' : editTitle;

  return (
    <PageLayout title={titleText} wrapperClassName='flex flex-col gap-4'>
      <ComplaintForm />
    </PageLayout>
  );
};
